/** True when horizontal overflow content should show a fade mask. */
export function needsFade(scrollWidth: number, clientWidth: number): boolean {
  return scrollWidth > clientWidth + 1;
}
